import React from 'react';
import FlyoutSwitch, {FORECASTING_FLYOUT_MODE} from '../common/FlyoutSwitch';

const FlyoutAssumptions = () => {
	return <FlyoutSwitch startMode={FORECASTING_FLYOUT_MODE.ASSUMPTION_LIST} />;
};

export default FlyoutAssumptions;
